




























































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import { ICommunicationData, ICommunication, ICommunicationReport } from "@/entities";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import NavButtons from "../../Workspace/Components/NavigationButtons.vue"; // "./NavigationButtons.vue"

const namespace: string = "communication";

@Component({
  components: {
      VJsonschemaForm,
      NavButtons
  }
})
export default class SectionContainer extends Vue {

    @Prop() report!: ICommunicationReport;
    @Prop() template!: any;
    @Prop() selectedKey!: any;
    @Prop() editable!: boolean;
    @Prop() isDirty!: boolean;
    @Prop( { default: true } ) isLocked!: boolean;
    @Prop( { default: false } ) canManage!: boolean;
    @Getter("sections", { namespace }) subSections: any;
    @Action("updateReport", { namespace }) updateReport: any;
    @Action("submitReport", { namespace }) submitReport: any;

    formValid: boolean = false;

    get subSchema() {        
        return this.template.properties[this.selectedKey];
    }

    /** event for menu change */
    menuChanged(menu) {
        if(this.isDirty && this.editable) {
            this.updateReport(this.report)
            .then((resp) => {
                this.$emit('menuChanged', menu);
            });
        } else {
            this.$emit('menuChanged', menu);
        }
    }

    submit() {
        this.$emit('submitted');
        // if(this.editable) {
        //     this.submitReport(this.report)
        //     .then((resp) => {
        //         this.$emit('submitted');
        //     });
        // }        
    }

}

